import useUrlNavigation from '../hooks/useUrlNavigation'
import './ErrorPage.scss'
import { ErrorInfoSvg, ErrorPageSvg } from './Svgs'

const ErrorPage = ({ error }: {
    error: {
        header: string;
        message: string;
    }
}) => {
    const { navigate_dashboard } = useUrlNavigation()

    return (
        <div className='error__page__container'>
            <div className='error__page__svg__container'>
                <ErrorPageSvg />
            </div>
            <div className='error__page__content__container'>
                <div className='error__page__content__title__container'>
                    <div className='error__page__content__title__icon'>
                        <ErrorInfoSvg />
                    </div>
                    <span className='error__page__content__title'>
                        {error?.header}
                    </span>
                </div>
                <div className='error__page__content__description'>
                    {error?.message}
                </div>
                <button className='error__page__back__button' onClick={navigate_dashboard}>
                    Return Home
                </button>
            </div>
        </div>
    )
}

export default ErrorPage